import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { Subject, takeUntil } from 'rxjs';

import { AuthService } from '@excelway/services/auth.service';
import { AutorizationService } from '@excelway/services/autorization.service';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';

@Component({
  selector: 'board-settings',
  templateUrl: './board-settings.component.html',
})
export class BoardSettingsComponent implements OnInit {
  @ViewChild('drawer') drawer: MatDrawer;
  drawerMode: 'over' | 'side' = 'side';
  drawerOpened: boolean = true;
  isTemplate: boolean;
  boardPanels = [
    {
      id: 'object-details',
      icon: 'heroicons_outline:information-circle',
      title: 'Board details',
      description: ' Manage board informations and actions',
    },
    {
      id: 'access-invites',
      icon: 'heroicons_outline:user-group',
      title: 'Access & invite',
      description: 'Control board access and invite participants',
    },
    // {
    //   id: 'choose-notifications',
    //   icon: 'heroicons_outline:bell',
    //   title: 'Notifications',
    //   description: 'Choose your notification preferences',
    // },
    // {
    //   id: 'customize-cards-fields',
    //   icon: 'heroicons_outline:bell',
    //   title: 'Card fields',
    //   description: 'customise cards display fields',
    // },
  ];

  templatePanels = [
    {
      id: 'object-details',
      icon: 'heroicons_outline:information-circle',
      title: 'Template details',
      description: 'Manage template informations and actions',
    },
    {
      id: 'availability',
      icon: 'heroicons_outline:squares-plus',
      title: 'Availability',
      description: 'Set template accessibility scope',
    },
    {
      id: 'access-template',
      icon: 'heroicons_outline:user-group',
      title: 'Access',
      description: ' Control template members access',
    },
    {
      id: 'tags',
      icon: 'heroicons_outline:tag',
      title: 'Tags',
      description: 'Control template tags',
    },
    {
      id: 'custom-fields',
      icon: 'heroicons_outline:queue-list',
      title: 'Item fields ',
      description: 'Customize Item Display Fields',
    },
  ];
  selectedPanel: string;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  role: string;

  /**
   * Constructor
   */
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data,
    private _changeDetectorRef: ChangeDetectorRef,
    public _matDialogRef: MatDialogRef<BoardSettingsComponent>,
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private authService: AuthService,
    private _permissionService: AutorizationService
  ) {
    if (data.tabToOpen) {
      this.selectedPanel = this.data.tabToOpen;
    } else {
      this.selectedPanel = 'object-details';
    }
  }

  ngOnInit(): void {
    this.isTemplate = this.data.value?.isTemplate;
    // Subscribe to media changes
    this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
        // Set the drawerMode and drawerOpened
        if (matchingAliases.includes('lg')) {
          this.drawerMode = 'side';
          this.drawerOpened = true;
        } else {
          this.drawerMode = 'over';
          this.drawerOpened = false;
        }

        // Mark for check
        this._changeDetectorRef.markForCheck();
      });
    this.getUserRole();
  }

  getUserRole = (): void => {
    this.authService.getAuthUser().then(identity => {
      if (identity) {
        this._permissionService
          .getAccessLevel(this.data.id, identity.id)
          .subscribe(response => {
            this.role = response.role;
          });
      }
    });
  };

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Navigate to the panel
   *
   * @param panel
   */
  goToPanel(panel: string): void {
    this.selectedPanel = panel;

    // Close the drawer on 'over' mode
    if (this.drawerMode === 'over') {
      this.drawer.close();
    }
  }

  /**
   * Get the details of the panel
   *
   * @param id
   */
  getPanelInfo(id: string): any {
    if (!this.isTemplate) {
      return this.boardPanels.find(panel => panel.id === id);
    } else {
      return this.templatePanels.find(panel => panel.id === id);
    }
  }

  /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
